/**
 * "/privacy" — public Privacy Policy, reachable logged in or out.
 * Linked from the landing footer and the sign-up consent.
 */
import { createFileRoute } from '@tanstack/react-router';
import { PRIVACY_POLICY } from '@finmin/ui';
import { LegalPage } from '@/features/legal/legal-page';

export const Route = createFileRoute('/privacy')({
  component: () => <LegalPage doc={PRIVACY_POLICY} />,
});
